import { Bell, Code2, Clock3, LayoutList, LogOut, PlusSquare, UserRound, Users } from "lucide-react";

import AdminClientsView from "./AdminClientsView";
import AdminDevelopersView from "./AdminDevelopersView";
import ClientPackagesView from "./ClientPackagesView";
import NewTicketView from "./NewTicketView";
import NotificationsView from "./NotificationsView";
import ProfileView from "./ProfileView";
import TicketDetailView from "./TicketDetailView";
import TicketsView from "./TicketsView";

export default function SupportPortalConnectedView({ portal }) {
  const {
    clients: { selectedClientId, setSelectedClientId },
    navigation: { activeView, setActiveView },
    notifications: { markAsRead, notifications, unreadCount },
    session: { handleLogout, user },
    tickets: { tickets },
  } = portal;
  const clientMenuItems = [
    { id: "tickets", label: "Tickets", icon: LayoutList },
    { id: "new-ticket", label: "Ajouter un ticket", icon: PlusSquare },
    { id: "packages", label: "Mes forfaits", icon: Clock3 },
    { id: "notifications", label: "Notifications", icon: Bell, badge: unreadCount },
    { id: "profile", label: "Infos client", icon: UserRound },
  ];

  const adminMenuItems = [
    { id: "tickets", label: "Tickets", icon: LayoutList },
    { id: "clients", label: "Clients", icon: Users },
    { id: "developers", label: "Développeurs", icon: Code2 },
    { id: "notifications", label: "Notifications", icon: Bell, badge: unreadCount },
    { id: "profile", label: "Infos support", icon: UserRound },
  ];

  const developerMenuItems = [
    { id: "tickets", label: "Tickets", icon: LayoutList },
    { id: "notifications", label: "Notifications", icon: Bell, badge: unreadCount },
    { id: "profile", label: "Infos développeur", icon: Code2 },
  ];

  const menuItems = user?.role === "admin" ? adminMenuItems : user?.role === "developer" ? developerMenuItems : clientMenuItems;

  const renderConnectedView = () => (
    <section className="support-shell">
      <div className="container support-app-layout">
        <aside className="support-app-sidebar">
          <div className="support-app-sidebar-top">
            <div className="support-app-brand">
              <span className="support-app-brand-mark">
                {user.role === "admin" ? "A" : user.role === "developer" ? "D" : "C"}
              </span>
              <div>
                <strong>{user.company_name}</strong>
                <p>{user.full_name}</p>
              </div>
            </div>

            <nav className="support-nav">
              {menuItems.map((item) => {
                const Icon = item.icon;
                return (
                  <button
                    key={item.id}
                    type="button"
                    className={`support-nav-item ${activeView === item.id ? "is-active" : ""}`}
                    onClick={() => setActiveView(item.id)}
                  >
                    <span className="support-nav-item-main">
                      <Icon className="w-4 h-4" />
                      {item.label}
                    </span>
                    {item.badge > 0 && <span className="support-nav-badge">{item.badge}</span>}
                  </button>
                );
              })}
            </nav>
          </div>

          <div className="support-app-sidebar-bottom">
            <button type="button" className="support-nav-item" onClick={handleLogout}>
              <span className="support-nav-item-main">
                <LogOut className="w-4 h-4" />
                Deconnexion
              </span>
            </button>
          </div>
        </aside>

        <main className="support-app-main">
          {!["clients", "developers"].includes(activeView) && (
            <div className="support-app-main-header">
              <div>
                <h1 className="heading-2">
                  {activeView === "tickets" && "Tickets"}
                  {activeView === "ticket-detail" && "Detail du ticket"}
                  {activeView === "new-ticket" && "Ajouter un ticket"}
                  {activeView === "packages" && "Mes forfaits"}
                  {activeView === "notifications" && "Notifications"}
                  {activeView === "profile" &&
                    (user.role === "admin"
                      ? "Infos support"
                      : user.role === "developer"
                        ? "Infos développeur"
                        : "Infos client")}
                </h1>
                <p className="body-small">
                  {activeView === "tickets" && "Du plus recent au moins recent"}
                  {activeView === "ticket-detail" &&
                    "Vue détaillée d'un ticket avec conversation, pièces jointes et suivi"}
                  {activeView === "notifications" && "Suivi des alertes de l'espace support"}
                  {activeView === "new-ticket" && "Création d'une nouvelle demande"}
                  {activeView === "packages" && "Suivi de vos forfaits de maintenance"}
                  {activeView === "profile" && "Informations du compte courant"}
                </p>
              </div>
              {selectedClientId && (activeView === "tickets" || activeView === "ticket-detail") && user.role === "admin" && (
                <button type="button" className="btn-secondary" onClick={() => setSelectedClientId("")}>
                  Tous les clients
                </button>
              )}
            </div>
          )}

          {activeView === "tickets" && <TicketsView portal={portal} />}
          {activeView === "ticket-detail" && <TicketDetailView portal={portal} />}
          {activeView === "new-ticket" && user.role === "client" && <NewTicketView portal={portal} />}
          {activeView === "packages" && user.role === "client" && (
            <ClientPackagesView user={user} onContact={() => setActiveView("new-ticket")} />
          )}
          {activeView === "notifications" && (
            <NotificationsView notifications={notifications} onMarkAsRead={markAsRead} />
          )}
          {activeView === "profile" && <ProfileView user={user} ticketsCount={tickets.length} />}
          {activeView === "clients" && user.role === "admin" && <AdminClientsView portal={portal} />}
          {activeView === "developers" && user.role === "admin" && <AdminDevelopersView portal={portal} />}
        </main>
      </div>
    </section>
  );

  return renderConnectedView();
}
